import FontAwesomeProIcon from '@ui/components/FontAwesomeProIcon/FontAwesomeProIcon';
import styles from '@ui/components/FileUpload/FileUpload.module.scss';
import Button from '@ui/components/Button/Button';
import React from 'react';

export function getFileSize(bytes) {
  const kb = bytes / 1000;
  const mb = bytes / 1000000;

  if (mb >= 1.0) {
    return `${Math.round(mb * 10) / 10} MB`;
  }

  return `${Math.round(kb * 10) / 10} KB`;
}

export function getFileTypeName(type) {
  switch (type) {
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'Word';
    case 'application/excel':
    case 'application/vnd.ms-excel':
      return 'Excel';
    case 'image/tiff':
      return 'TIFF';
    case 'image/png':
      return 'PNG';
    case 'image/jpeg':
      return 'JPEG';
    case 'application/pdf':
      return 'PDF';
    default:
      return 'Andere Datei';
  }
}

function fileIcon(type) {
  switch (type) {
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return 'file-word';
    case 'application/excel':
    case 'application/vnd.ms-excel':
      return 'file-excel';
    case 'image/tiff':
    case 'image/png':
    case 'image/jpeg':
      return 'file-image';
    case 'application/pdf':
      return 'file-pdf';
    default:
      return 'file-alt';
  }
}

const FileItem = ({ file, index, onFileRemove }) => {
  const handleOnFileRemove = () => {
    onFileRemove(index);
  };

  return (
    <div className={styles.fileItem}>
      <FontAwesomeProIcon
        className={styles.fileIcon}
        icon={fileIcon(file.type)}
      />
      <div className={styles.fileInfo}>
        <span className={styles.fileName}>{file.name}</span>
        <div>
          <span className={styles.fileSize}>{getFileSize(file.size)}</span>
          <span className={styles.separator}>|</span>
          <span className={styles.fileType}>{getFileTypeName(file.type)}</span>
        </div>
      </div>
      <Button
        aria-label={`${file.name} entfernen`}
        className={styles.trashIcon}
        onClick={handleOnFileRemove}
        shape="bubble"
        size="small"
        variant="bubble"
      >
        <FontAwesomeProIcon icon="trash-alt" />
      </Button>
    </div>
  );
};

const FileList = ({ files, onFileRemove }) => {
  if (!files) {
    return null;
  }

  return (
    <ul className={styles.fileList}>
      {files.map((file, index) => (
        <li key={file.name}>
          <FileItem file={file} index={index} onFileRemove={onFileRemove} />
        </li>
      ))}
    </ul>
  );
};

export default FileList;
